import { put, select, takeLatest } from 'redux-saga/effects'
import { HANDLE_CHAT_WS_MESSAGE, HandleChatWsMessageActionType } from '../redux/chatMessagesReducer'
import { ADD_CHAT_MESSAGE, TRANSLATE_CHAT_MESSAGE } from '../redux/chatMessagesReducer'
import { RootReducer } from '../redux/rootReducer'

function* HandleChatWsMessageFlow({ payload }: HandleChatWsMessageActionType): Generator<any, void, any> {
  if (Object.keys(payload)[0] === 'new_message') {
    if (payload.to === 'tutor' || payload.to === 'both') {
      yield put(ADD_CHAT_MESSAGE(payload.new_message))
    }
  }
  if (Object.keys(payload)[0] === 'translated_message') {
    const user = yield select((state: RootReducer) => state.chatMessagesReducer.user)
    if (payload.translated_message.role === user) {
      yield put(
        TRANSLATE_CHAT_MESSAGE({ id: payload.translated_message.id, message: payload.translated_message.message })
      )
    }
  }
}

export default function* HandleChatWsMessageSaga(): Generator<any, void, any> {
  yield takeLatest([HANDLE_CHAT_WS_MESSAGE], HandleChatWsMessageFlow)
}
